import { type TextLayer } from '@meitu/saas-editor-core/es/layers/text-layer';
import { isSafari } from '@meitu/saas-editor-core/es/utils/browser-kit';
import { TextAlignType, TextWritingType, type ITextLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { TextAlignmentGroup } from '@/components/text-alignment-group';
import { useEditor } from '@/hooks/use-editor';
import { useEffectiveShapeExtension, useLayerProps } from '../../hooks';
import { type WidgetCommonProps } from '../../types';
import { Tracker } from '../../utils';

type Props = WidgetCommonProps;

export const TextAlignment: React.FC<Props> = ({ layerId, recordId }) => {
    const editor = useEditor();

    const props = useLayerProps(editor, (layer) => {
        if (!layer) return null;

        const layerData = layer.data as ITextLayerProps;
        const { writingMode, textAlign } = layerData;

        return {
            writingMode,
            textAlign,
        };
    });

    const writingMode = props ? props.writingMode : TextWritingType.HORIZONTAL_TB;
    const textAlign = (() => {
        if (isSafari && props?.textAlign === TextAlignType.JUSTIFY) return TextAlignType.LEFT; // HACK: Safari 下，隐藏 justify 选项，ui 上显示 left
        return props?.textAlign || TextAlignType.CENTER;
    })();
    const shapeExtension = useEffectiveShapeExtension(layerId);

    const disabled = !!shapeExtension;

    const handleChange = (value: TextAlignType) => {
        editor.getInstance<TextLayer>('TextLayer').setTextAlign(layerId, value);

        Tracker.setAlignment({
            recordId,
            stageType: editor.services.editor.getCanvasType(),
            writingMode: TextWritingType.HORIZONTAL_TB,
            type: 'textAlign',
            value,
        });
    };

    return (
        <TextAlignmentGroup
            writingMode={writingMode}
            textAlign={textAlign}
            disabled={disabled}
            hideJustify={isSafari}
            onChange={(_, value) => handleChange(value as TextAlignType)}
        />
    );
};
